import { useAuthToken } from '@features/authentication';
import { MediaIdentifier, Track } from '@features/Clip';
import { useSelectedClipMediaResolver } from '@features/Clip/hooks/useSelectedClipMediaResolver';
import { useSelectedClipTracks } from '@features/Clip/hooks/useSelectedClipTracks';
import { useMemo } from 'react';

export const useMedia = () => {
    const { data: mediaRaw, isLoading: isMediaLoading } =
        useSelectedClipMediaResolver('PROXY');
    const { data: tracksRaw, isLoading: isTracksLoading } =
        useSelectedClipTracks('STITCH', 'LOW');
    const token = useAuthToken();

    const media = useMemo(
        (): MediaIdentifier | null => mediaRaw || null,
        [mediaRaw],
    );
    const tracks = useMemo(
        (): Track[] => (tracksRaw ? (tracksRaw as Track[]) : []),
        [tracksRaw],
    );

    const src = useMemo(() => {
        if (!media?.href || !token) return '';

        const isPlatformApi = media.href.includes('platform.limecraft.com');
        const baseUrl = isPlatformApi ? `${media.href}/data` : media.href;

        const url = new URL(baseUrl);
        url.searchParams.set('access_token', token);
        return url.toString();
    }, [media?.href, token]);

    return {
        src,
        media,
        tracks,
        isLoading: isMediaLoading || isTracksLoading,
    };
};
